import React, { Component } from 'react'
import { Provider } from 'react-redux'
import { ConnectedRouter as Router } from 'connected-react-router'
import ClearCache from 'react-clear-cache';
import { GridThemeProvider } from 'styled-bootstrap-grid'
import { ThemeProvider } from 'styled-components'
import { BaseCSS } from 'styled-bootstrap-grid'
import GlobalStyle from 'styled/globalStyles'
import { theme } from 'styled/theme'
import { Routes } from 'routes'
import configureStore from 'store'
import { history } from 'routes'
import Alert from 'components/UI/Alert'
import { TokenStorage } from './services/tokenService'
import { admin, authenticated } from './ducks/auth/actions'
import { parseJwt } from './services/parse'
// @ts-ignore
import LoadingWrapper from './components/content/LoadingWrapper/LoadingWrapper'

export const store = configureStore(history)

const gridTheme = {
  breakpoints: {
    xl: 1114,
    lg: 992,
    md: 768,
    sm: 576,
    xs: 575
  },
  row: {
    // padding: 10, // default 15
  },
  col: {
    // padding: 5, // default 15
  },
  container: {
    // padding: 0, // default 15
    maxWidth: {
      xl: 1054,
      lg: 960,
      md: 720,
      sm: 540,
      xs: 540
    }
  }
}

// const App: React.FC = () => {
// class AppointmentInfo extends Component<Props, State> {
//   constructor(props: Props) {
//     super(props)
//
//     this.state = {
//       appointmentType: typeOptions.find(
//         item => item.value === AppointmentVariant.Appointment
//       )
//     }
//   }
interface State {
  isLoading: boolean
}
// tslint:disable-next-line:no-empty-interface
interface Props {}
class App extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    const state = store.getState()

    this.state = {
      isLoading: state.loading.isLoading
    }
  }
  componentDidMount(): void {
    const unlisten = history.listen((location, action) => {
        console.log(action, location.pathname, location.state);
    });

    if (!!TokenStorage.getToken()) {
      const parsedToken = parseJwt(TokenStorage.getToken())
      if (parsedToken.auth === 'ROLE_ADMIN') {
        store.dispatch(admin(true))
      }
      store.dispatch(authenticated())
    }
  }
  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<State>,
    snapshot?: any
  ): void {
    console.log('here')
  }

  render() {
    return (
      <ThemeProvider theme={theme}>
        <GridThemeProvider gridTheme={gridTheme}>
          <Provider store={store}>
            <ClearCache>
                {({ loading, isLatestVersion, emptyCacheStorage }: { loading: boolean; isLatestVersion: boolean; emptyCacheStorage: (version?: string | undefined) => Promise<void>; }) => {
                    // if (loading) return null;
                    if (!loading && !isLatestVersion) {
                      emptyCacheStorage();
                    }
                    return (
                        <LoadingWrapper
                            child={
                                <Router history={history}>
                                    <Routes />
                                    <BaseCSS />
                                    <GlobalStyle />
                                    <Alert />
                                </Router>
                            }
                        />
                    )
                }}
            </ClearCache>
          </Provider>
        </GridThemeProvider>
      </ThemeProvider>
    )
  }
}

export default App
